const sayAsSerializer = ((node, children) => {
  return `<say-as interpret-as="${node.interpretAs}">${children}</say-as>`;
});

export { sayAsSerializer };
//# sourceMappingURL=serializer.js.map
